import React from 'react';

import styles from './PayoutsSkeletonLoader.module.scss';

type Props = {
  width: number;
  height: number;
  borderRadius?: string;
}

const PayoutsSkeletonLoader = ({
  width,
  height,
  borderRadius,
}: Props) => (
  <div
    className={styles.skeletonLoader}
    style={{
      width,
      height,
      borderRadius: borderRadius || '',
    }}
  />
);
export default PayoutsSkeletonLoader;
